import type { IUnredeemedPackageResponse } from "@/types"

export class UnredeemedPackage {
  public name?: string
  public purchaseDate?: Date
  public email?: string
  public token?: string
  public link?: string

  constructor(unredeemedPackage: Partial<UnredeemedPackage>) {
    this.name = unredeemedPackage.name ?? "—"
    this.purchaseDate = unredeemedPackage.purchaseDate
    this.email = unredeemedPackage.email
    this.token = unredeemedPackage.token
    this.link = unredeemedPackage.link
  }

  public static fromResponse(response: IUnredeemedPackageResponse): UnredeemedPackage {
    return new UnredeemedPackage({
      name: response.ProductName,
      purchaseDate: response.DateOfPurchase,
      email: response.Email,
      token: response.Token,
      link: response.Link,
    })
  }
}
